import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({ href, children, ...props }: any) => {
    if (!href) return <span {...props}>{children}</span>;
    if (href.startsWith('http') || href.startsWith('#') || href.startsWith('tel:') || href.startsWith('mailto:')) {
        return <a href={href} {...props}>{children}</a>;
    }
    return <RouterLink to={href} {...props}>{children}</RouterLink>;
};

export default Link;
export { Link };
